import { useGetFaireAcademyPageState } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useGetFaireAcademyPageState";
import {
  usePopSignUp,
  SignUpType,
  SignUpElement,
} from "@faire/deprecated-retailer-visitor-shared/lib/popSignUp";
import { OWF_SECTION_NAME } from "@faire/deprecated-retailer-visitor-shared/views/open-with-faire/OpenWithFaireFaireAcademyLandingPage/types";
import { trackOpenWithFaireSignUpCtaClick } from "@faire/web-api--source/events/openWithFaire/click/signUpCta";
import { Button } from "@faire/web/slate/Button";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const SignUpButton: React.FC<{
  source: keyof typeof OWF_SECTION_NAME;
}> = ({ source }) => {
  const { pageState } = useGetFaireAcademyPageState();
  const { popSignUp } = usePopSignUp();

  const handleSignUp = () => {
    popSignUp(
      SignUpType.GENERIC,
      () => trackOpenWithFaireSignUpCtaClick(pageState, source),
      {
        element:
          source === "FOOTER_CARD" ? SignUpElement.FOOTER : SignUpElement.HERO,
        sourceId: `open_with_faire_academy_signup_cta_${source}`,
      }
    );
  };

  return (
    <FitContentButton
      onClick={handleSignUp}
      variant="secondary"
      data-test-id="owf-signup-cta"
    >
      <StrictLocalMsg
        id="4WpQes"
        defaultMessage="Sign up to get started"
        description={{
          text: "CTA to sign up for Open with Faire, a program we offer for helping opening retailers to start their business",
          img: "https://cdn.faire.com/fastly/cfc5b0d3ed9509ab4818e9b1e2f6c222949b6ab429467fabad21d6a9346c2d70.png",
        }}
      />
    </FitContentButton>
  );
};

const FitContentButton = styled(Button)`
  width: fit-content;
  align-self: center;

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
